var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThemeSunsetBackScroll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3991.563,
    height: 183.374,
    viewBox: "0 0 3991.563 183.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.485,
    y1: 1.552,
    x2: 0.487,
    y2: 0.621,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eac676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5083a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#272b5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f07c6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b1f52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e5b66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "MASQUE-3",
    "data-name": "MASQUE",
    width: 2262.563,
    height: 183.374,
    transform: "translate(200.437 865.422)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "MASQUE-4",
    "data-name": "MASQUE",
    width: 3991.563,
    height: 183.374,
    transform: "translate(31.377 -153.927)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -3.332,
    y1: 17.467,
    x2: -3.332,
    y2: 17.457,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#001871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#011632"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND",
    transform: "translate(-200.437 -865.422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PLAN_04",
    "data-name": "PLAN 04",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "CLOUD_02",
    "data-name": "CLOUD 02",
    d: "M482.721,79.541a3.1,3.1,0,0,1-2.3-5.181,20.8,20.8,0,0,1,15.627-7.045,21.068,21.068,0,0,1,3.266.255,32.421,32.421,0,0,1,54.569-5.94,24.916,24.916,0,0,1,38.848,14.035,3.1,3.1,0,0,1-3,3.874Z",
    transform: "translate(2365.372 837.663)",
    fill: "#eda885"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PLAN_03",
    "data-name": "PLAN 03",
    transform: "translate(536 -1123.682)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-9",
    d: "M0,2134.037v86.889H1115.423q-5.444-21.466-18.589-28.515c-11.367-6.095-30.153,39.554-56.3,39.554-69.705,0-169.973-39-224.256-43.527-32.433-2.7-45.5-19.467-72.229-21.448-31.524-2.336-51.263-30.132-80.9-32.96-40.673-3.881,8.043-29.969-62.293-20.975-3.164.4-39.288-19.485-43.211-19.713-29.9-1.737-113.124.352-167.955.035-29.864-.173-97.177-15.262-133.39-15.706-18.3-.225-46.435-10.378-78.091-.033-20.861,6.817-44.246,35.732-63.838,35.451Q56.856,2112.265,0,2134.037Z",
    transform: "translate(-366.941 -23.96)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-9-2",
    "data-name": "Rectangle-Copy-9",
    d: "M1405.739,2153.31v114.325H0q6.128-28.244,20.927-37.518c12.8-8.02,33.946,52.043,63.383,52.043,78.474,0,191.355-51.321,252.466-57.27,36.513-3.555,51.225-25.614,81.315-28.22,35.489-3.074-2.4-39.638,30.965-43.36,45.789-5.107,51.06-39.439,130.244-27.605,3.563.532,44.231-25.638,48.647-25.938,33.659-2.286,127.354.463,189.083.046,33.62-.227,109.4-20.082,150.17-20.666,20.607-.3,52.277-13.655,87.915-.043,23.486,8.97,49.812,47.014,71.869,46.645C1170.149,2125.025,1363.067,2134.213,1405.739,2153.31Z",
    transform: "translate(929.059 -74.155)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-11",
    d: "M3473.642,2185.927H3347.329L2040,2283.8q5.443-21.466,18.589-28.515c11.367-6.095,21.321-14,47.469-14,49.8,0,197.254-32.51,295.065-69.863,39.1-14.933,67.114-55.844,82.617-57.135,32.433-2.7,47.867-22.241,74.594-24.222,31.524-2.336,65.445,11.8,95.084,8.976,40.673-3.882,87.7-29.928,158.031-20.934,27.283,3.489,84.167-19.366,146.192-19.725,29.864-.173,97.178-15.263,133.391-15.707,18.3-.225,46.435-10.378,78.091-.033,20.862,6.817,44.245,35.732,63.839,35.451C3271.3,2077.541,3385.456,2074.28,3473.642,2185.927Z",
    transform: "translate(-1763.507)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-10",
    d: "M-536,2198.037v86.889H579.423q-5.444-21.466-18.589-28.515c-11.367-6.095-21.321-14-47.469-14-69.705,0-131.494-24.606-185.776-29.128-32.433-2.7-47.867-22.241-74.594-24.222-31.523-2.336-65.445,11.8-95.084,8.976C117.238,2194.156,70.216,2168.11-.12,2177.1c-27.283,3.489-84.167-19.366-146.192-19.725-29.864-.173-97.177-15.263-133.39-15.707-18.3-.225-46.435-10.378-78.091-.033-20.861,6.817-44.246,35.732-63.838,35.451Q-479.144,2176.265-536,2198.037Z",
    transform: "translate(0 -67.774)",
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PLAN_02",
    "data-name": "PLAN 02",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "CLOUD_01",
    "data-name": "CLOUD 01",
    d: "M440.832,113.658a5.076,5.076,0,0,0,4.49-7.487,22.927,22.927,0,0,0-32.713-7.928,45.813,45.813,0,0,0-58.355-20.026A58.972,58.972,0,0,0,246.288,90.276a38.193,38.193,0,0,0-37.525,14.265,17.541,17.541,0,0,0-14.371-.668c-5.167,2.044-3.593,9.785,1.965,9.785Z",
    transform: "translate(4112.9 880.907)",
    fill: "#ffc7aa",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "CLOUD_03",
    "data-name": "CLOUD 03",
    d: "M762.969,342.565a13.326,13.326,0,0,0-6.839,1.891,17.467,17.467,0,0,0-25.034-7.365,34.9,34.9,0,0,0-62.665-17.256,37.883,37.883,0,0,0-51.031,7.706,29.125,29.125,0,0,0-36.157,10.494,13.375,13.375,0,0,0-17.075,4.28,13.41,13.41,0,0,0-16.338,2.888,5.415,5.415,0,0,0,4.135,8.94l214.692.182c5.563,0,7.6-7.477,2.711-10.136A13.324,13.324,0,0,0,762.969,342.565Z",
    transform: "translate(4886.511 634.342)",
    fill: "#ffc7aa",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "PLAN_01",
    "data-name": "PLAN 01",
    transform: "translate(169.059 1019.349)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3505",
    "data-name": "Group 3505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-9",
    d: "M238.806,2393l18.788,1.412,8.888,2.336,17.576.5,14.817,3.9,34.778,3.2,31.9,5.152,40.054,2.362,14.594,3.394,25.991,1.321,26.125,3.382,5.3,2.052H0l5.3-2.052,26.125-3.382,25.991-1.321,14.594-3.394,40.054-2.362,31.9-5.152,34.778-3.2,14.817-3.9,17.576-.5,8.888-2.336Z",
    transform: "translate(0 -2386.061)",
    fill: "#2b4972"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-8",
    d: "M552.806,2371l18.788,1.75,8.888,2.9,17.576.621,14.817,4.834,34.778,3.971,31.9,6.384,40.054,2.927,14.594,4.205,25.992,1.637,26.125,4.191,5.3,2.542H314l5.3-2.542,26.125-4.191,25.991-1.637,14.594-4.205,40.054-2.927,31.9-6.384,34.778-3.971,14.817-4.834,17.576-.621,8.888-2.9Z",
    transform: "translate(-205.718 -2371)",
    fill: "#2b4972"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-9-2",
    "data-name": "Combined-Shape-Copy-9",
    d: "M1212.806,2393l18.787,1.412,8.888,2.336,17.576.5,14.817,3.9,34.778,3.2,31.9,5.152,40.054,2.362,14.594,3.394,25.991,1.321,26.125,3.382,5.3,2.052H974l5.3-2.052,26.125-3.382,25.992-1.321,14.594-3.394,40.054-2.362,31.9-5.152,34.778-3.2,14.817-3.9,17.576-.5,8.888-2.336Z",
    transform: "translate(-638.12 -2386.061)",
    fill: "#1f385c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-8-2",
    "data-name": "Combined-Shape-Copy-8",
    d: "M1526.806,2371l18.788,1.75,8.888,2.9,17.576.621,14.817,4.834,34.778,3.971,31.9,6.384,40.054,2.927,14.594,4.205,25.991,1.637,26.125,4.191,5.3,2.542H1288l5.3-2.542,26.125-4.191,25.991-1.637,14.594-4.205,40.054-2.927,31.9-6.384,34.778-3.971,14.817-4.834,17.576-.621,8.888-2.9Z",
    transform: "translate(-843.838 -2371)",
    fill: "#2b4972"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3506",
    "data-name": "Group 3506",
    transform: "translate(2175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-9-3",
    "data-name": "Combined-Shape-Copy-9",
    d: "M238.806,2393l18.788,1.412,8.888,2.336,17.576.5,14.817,3.9,34.778,3.2,31.9,5.152,40.054,2.362,14.594,3.394,25.991,1.321,26.125,3.382,5.3,2.052H0l5.3-2.052,26.125-3.382,25.991-1.321,14.594-3.394,40.054-2.362,31.9-5.152,34.778-3.2,14.817-3.9,17.576-.5,8.888-2.336Z",
    transform: "translate(0 -2386.061)",
    fill: "#2b4972"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-8-3",
    "data-name": "Combined-Shape-Copy-8",
    d: "M552.806,2371l18.788,1.75,8.888,2.9,17.576.621,14.817,4.834,34.778,3.971,31.9,6.384,40.054,2.927,14.594,4.205,25.992,1.637,26.125,4.191,5.3,2.542H314l5.3-2.542,26.125-4.191,25.991-1.637,14.594-4.205,40.054-2.927,31.9-6.384,34.778-3.971,14.817-4.834,17.576-.621,8.888-2.9Z",
    transform: "translate(-205.718 -2371)",
    fill: "#2b4972"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-9-4",
    "data-name": "Combined-Shape-Copy-9",
    d: "M1212.806,2393l18.787,1.412,8.888,2.336,17.576.5,14.817,3.9,34.778,3.2,31.9,5.152,40.054,2.362,14.594,3.394,25.991,1.321,26.125,3.382,5.3,2.052H974l5.3-2.052,26.125-3.382,25.992-1.321,14.594-3.394,40.054-2.362,31.9-5.152,34.778-3.2,14.817-3.9,17.576-.5,8.888-2.336Z",
    transform: "translate(-638.12 -2386.061)",
    fill: "#1f385c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-8-4",
    "data-name": "Combined-Shape-Copy-8",
    d: "M1526.806,2371l18.788,1.75,8.888,2.9,17.576.621,14.817,4.834,34.778,3.971,31.9,6.384,40.054,2.927,14.594,4.205,25.991,1.637,26.125,4.191,5.3,2.542H1288l5.3-2.542,26.125-4.191,25.991-1.637,14.594-4.205,40.054-2.927,31.9-6.384,34.778-3.971,14.817-4.834,17.576-.621,8.888-2.9Z",
    transform: "translate(-843.838 -2371)",
    fill: "#2b4972"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3507",
    "data-name": "Group 3507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-9-5",
    "data-name": "Combined-Shape-Copy-9",
    d: "M3879.806,2393l-18.787,1.412-8.888,2.336-17.576.5-14.816,3.9-34.779,3.2-31.9,5.152-40.054,2.362-14.594,3.394-25.991,1.321-26.125,3.382-5.3,2.052h477.613l-5.3-2.052-26.125-3.382-25.992-1.321-14.594-3.394-40.054-2.362-31.9-5.152-34.778-3.2-14.817-3.9-17.576-.5-8.888-2.336Z",
    transform: "translate(-2385.413 -2386.061)",
    fill: "#1f385c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-8-5",
    "data-name": "Combined-Shape-Copy-8",
    d: "M3565.806,2371l-18.788,1.75-8.888,2.9-17.576.621-14.817,4.834-34.778,3.971-31.9,6.384-40.054,2.927-14.594,4.205-25.991,1.637-26.125,4.191-5.3,2.542h477.613l-5.3-2.542-26.125-4.191-25.992-1.637-14.594-4.205-40.054-2.927-31.9-6.384-34.778-3.971-14.817-4.834-17.576-.621-8.888-2.9Z",
    transform: "translate(-2179.695 -2371)",
    fill: "#2b4972"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-9-6",
    "data-name": "Combined-Shape-Copy-9",
    d: "M4853.806,2393l-18.788,1.412-8.888,2.336-17.576.5-14.817,3.9-34.778,3.2-31.9,5.152-40.054,2.362-14.594,3.394-25.991,1.321-26.125,3.382-5.3,2.052h477.613l-5.3-2.052-26.125-3.382-25.992-1.321-14.594-3.394-40.054-2.362-31.9-5.152-34.778-3.2-14.817-3.9-17.577-.5-8.887-2.336Z",
    transform: "translate(-3023.533 -2386.061)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-8-6",
    "data-name": "Combined-Shape-Copy-8",
    d: "M4539.806,2371l-18.787,1.75-8.888,2.9-17.577.621-14.816,4.834-34.778,3.971-31.9,6.384-40.054,2.927-14.595,4.205-25.991,1.637-26.125,4.191-5.3,2.542h477.612l-5.3-2.542-26.125-4.191-25.991-1.637-14.595-4.205-40.054-2.927-31.9-6.384-34.778-3.971-14.816-4.834-17.577-.621-8.888-2.9Z",
    transform: "translate(-2817.814 -2371)",
    fill: "#1f385c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3508",
    "data-name": "Group 3508",
    transform: "translate(1916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-9-7",
    "data-name": "Combined-Shape-Copy-9",
    d: "M3879.806,2393l-18.787,1.412-8.888,2.336-17.576.5-14.816,3.9-34.779,3.2-31.9,5.152-40.054,2.362-14.594,3.394-25.991,1.321-26.125,3.382-5.3,2.052h477.613l-5.3-2.052-26.125-3.382-25.992-1.321-14.594-3.394-40.054-2.362-31.9-5.152-34.778-3.2-14.817-3.9-17.576-.5-8.888-2.336Z",
    transform: "translate(-2385.413 -2386.061)",
    fill: "#1f385c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-8-7",
    "data-name": "Combined-Shape-Copy-8",
    d: "M3565.806,2371l-18.788,1.75-8.888,2.9-17.576.621-14.817,4.834-34.778,3.971-31.9,6.384-40.054,2.927-14.594,4.205-25.991,1.637-26.125,4.191-5.3,2.542h477.613l-5.3-2.542-26.125-4.191-25.992-1.637-14.594-4.205-40.054-2.927-31.9-6.384-34.778-3.971-14.817-4.834-17.576-.621-8.888-2.9Z",
    transform: "translate(-2179.695 -2371)",
    fill: "#2b4972"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-9-8",
    "data-name": "Combined-Shape-Copy-9",
    d: "M4853.806,2393l-18.788,1.412-8.888,2.336-17.576.5-14.817,3.9-34.778,3.2-31.9,5.152-40.054,2.362-14.594,3.394-25.991,1.321-26.125,3.382-5.3,2.052h477.613l-5.3-2.052-26.125-3.382-25.992-1.321-14.594-3.394-40.054-2.362-31.9-5.152-34.778-3.2-14.817-3.9-17.577-.5-8.887-2.336Z",
    transform: "translate(-3023.533 -2386.061)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-8-8",
    "data-name": "Combined-Shape-Copy-8",
    d: "M4539.806,2371l-18.787,1.75-8.888,2.9-17.577.621-14.816,4.834-34.778,3.971-31.9,6.384-40.054,2.927-14.595,4.205-25.991,1.637-26.125,4.191-5.3,2.542h477.612l-5.3-2.542-26.125-4.191-25.991-1.637-14.595-4.205-40.054-2.927-31.9-6.384-34.778-3.971-14.816-4.834-17.577-.621-8.888-2.9Z",
    transform: "translate(-2817.814 -2371)",
    fill: "#1f385c"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeSunsetBackScroll);
export default __webpack_public_path__ + "static/media/theme-sunset-back-scroll.86099f32.svg";
export { ForwardRef as ReactComponent };